import { Container, Row, Col, Badge } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./hero.css";
import { Partners } from "../partners/partners";

export const Hero = () => {
  return (
    <section className="hero-section">
      {/* Purple glow orb */}
      <div className="hero-orb" />

      {/* Star dots */}
      <div className="stars" />

      <Container className="hero-content">
        <Row className="justify-content-center text-center">
          <Col xs={12} md={10} lg={10}>
            {/* Badge */}
            <div className="hero-badge-wrap mb-4">
              <span className="hero-badge">
                <Badge className="badge-new">Grow</Badge>
                Your Business With Us
              </span>
            </div>

            {/* Heading */}
            <h1 className="hero-heading">
              Scale Your Business with Proven
              <br />
              Digital Marketing Strategies
            </h1>
 
            {/* Subtext */}
            <p className="hero-sub">
              We specialize in connecting your business with the right audience
              through strategic marketing and branding solutions.
            </p>

            {/* CTA buttons */}
            <div className="hero-actions">
              <Link to="/contact" className="btn-get-in-touch-hero">
                Get More Leads<span className="arrow-icon">↗</span>
              </Link>
              <Link to="/services" className="btn-view-services">Our Services</Link>
            </div>
          </Col>
        </Row>
      </Container>

      {/* <Container className="partner-col">
        <Row>
          <Col>
          <Partners/>
          </Col>
        </Row>
      </Container> */}
    </section>
  );
};
